import { render, staticRenderFns } from "./CovidQuestions.vue?vue&type=template&id=51a4a055&"
import script from "./CovidQuestions.vue?vue&type=script&lang=js&"
export * from "./CovidQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports